export default class Path {
  static AUTH_URL = "https://staging-unilever.nexdegree.com/b/";

  static BASE_URL = "https://staging-unilever.nexdegree.com/b/v1";


  static AUTHENTICATE = Path.AUTH_URL + "o/token/";

  static REFRESH_TOKEN = Path.AUTH_URL + "o/token/";

  static USERVERIFICATION = Path.BASE_URL + "/user/verify/o/"

  static GET_CATEGORY = Path.BASE_URL + "/product_hierarchy/categories/";

  static GET_BRANDS = Path.BASE_URL + "/product_hierarchy/brands/";

  static GET_SKUS = Path.BASE_URL + "/product_hierarchy/master_skus/";

  static GET_REGIONS = Path.BASE_URL + "/geo_hierarchy/regions/";

  static GET_DEMAND_DRIVERS = Path.BASE_URL + "/enum/demmand_driver/";

  static GET_CHANNEL = Path.BASE_URL + "/channel_hierarchy/channels/";

  static POST_PRIMARY_DASHBOARD = Path.BASE_URL + "/sale/primary_dashboard/";

  static GET_DEMAND_PLANNER = Path.BASE_URL + "/demand_planner/fetch/";

  static POST_SECONDARY_DASHBOARD = Path.BASE_URL + "/sale/secondry_dashboard/";

  static POST_DOWNLOAD_PRIMARY_XLX = Path.BASE_URL + "/sale/export_primary_sale/";

  static POST_DOWNLOAD_FAFBReport_XLX = Path.BASE_URL + "/forecast/forecast_accuracy_regional_export/";


  static POST_COCT_ROB = Path.BASE_URL + "/sale/core_type/";

  static POST_DOWNLOAD_SECONDARY_XLX = Path.BASE_URL + "/sale/export_secondary_sale/";

  static GET_REGIONS_GROWTH = Path.BASE_URL + '/sale/region_growth/';

  static GET_CHANNEL_SALE = Path.BASE_URL + "/sale/channel_Sale/";

  static GET_SECONDARYSALE_ENDSTOCK = Path.BASE_URL + "/sale/sales_vs_endstock/";

  static GET_END_STOCK = Path.BASE_URL + "/sale/endstock_week_wise/";

  static GET_SECONDARY_SALE = Path.BASE_URL + "/sale/secondary_sale_week_wise/";

  static GET_CORE_TYPE_ = Path.BASE_URL + "/product_hierarchy/master_skus/core_type/";

  static GET_STAND_POINT_ = Path.BASE_URL + "/enum/standpoint/";



  // Prat Section Starting from here 
  static GET_PROMOTION_TYPE = Path.BASE_URL + "/enum/promotion_type_exclude_mtfts/";

  static GET_PROMOTION_LEVEL = Path.BASE_URL + "/enum/promotion_level/";

  // PRODUCT DETAILS SECTION
  static GET_PRODUCT_DEVISION = Path.BASE_URL + "/product_hierarchy/divisions/";

  static GET_PRODUCT_BRAND = Path.BASE_URL + "/product_hierarchy/brands/";

  static GET_PRODUCT_CATEGORY = Path.BASE_URL + "/product_hierarchy/categories/";

  static GET_PRODUCT_SKU = Path.BASE_URL + "/product_hierarchy/skus/";

  static GET_PRODUCT_MASTER_SKU = Path.BASE_URL + "/product_hierarchy/master_skus/";

  static GET_PRODUCT_VARIANTS = Path.BASE_URL + "/product_attributes/variants/";

  static GET_PRODUCT_FORMATS = Path.BASE_URL + "/product_attributes/formats/";

  static GET_PRODUCT_SIZE = Path.BASE_URL + "/product_attributes/sizes/";

  static GET_ACTIVITY_END_STOCK = Path.BASE_URL + "/activity/endstock/";

  static GET_PRODUCT_CUSTOMER = Path.BASE_URL + "/direct_customer/";



  // GEOGRAPHIC DETAIL

  static GET_GEO_AREA = Path.BASE_URL + "/geo_hierarchy/areas/";

  static GET_GEO_TOWNS = Path.BASE_URL + "/geo_hierarchy/territories/";

  static GET_GEO_REGION = Path.BASE_URL + "/geo_hierarchy/regions/";

  static GET_GEO_DISTRIBUTORS = Path.BASE_URL + "/geo_hierarchy/distributors/";

  static GET_DIRECT_CUSTOMER = Path.BASE_URL + "/direct_customer/";

  static GET_GEO_DISTRIBUTORS_ON_RESGION = Path.BASE_URL + "/geo_hierarchy/distributors/filter_on_regions/";


  // CHANNEL DETAIL

  static GET_MASTER_CHANNEL = Path.BASE_URL + "/channel_hierarchy/master_channels/";

  static GET_CHANNEL = Path.BASE_URL + "/channel_hierarchy/channels/";

  static GET_ELEMENT = Path.BASE_URL + "/channel_hierarchy/elements/";

  static GET_SUB_ELEMENT = Path.BASE_URL + "/channel_hierarchy/sub_elements/";

  // OUTLET   

  static GET_OUTLET_PROGRAM = Path.BASE_URL + "/outlet_attributes/outletprogram/";

  static GET_LOCATION_TYPE = Path.BASE_URL + "/outlet_attributes/locationtype/";

  static GET_TIER = Path.BASE_URL + "/outlet_attributes/tier/";

  static GET_PERFECT_VILLAGE = Path.BASE_URL + "/outlet_attributes/perfectvillage/";

  static GET_CHANNEL_TTS = Path.BASE_URL + "/outlet_attributes/channeltts/";

  static GET_CHAIN_OUTLETS = Path.BASE_URL + "/outlet_attributes/chainoutlet/";

  static GET_PERFECT_STORE = Path.BASE_URL + "/outlet_attributes/perfectstore/";

  static GET_PERFECT_STORE_COMPLIANCE = Path.BASE_URL + "/outlet_attributes/perfectstorecompliance/"

  static GET_OUTLET_CLASSIFICATION = Path.BASE_URL + "/outlet_attributes/outletclassification/";

  static GET_RANGE = Path.BASE_URL + "/outlet_attributes/range/";

  static GET_POINT_OF_CONSUMPTION = Path.BASE_URL + "/outlet_attributes/pointofconsumption/";

  static GET_LOYALITY_PROGRAM = Path.BASE_URL + "/outlet_attributes/loyaltyprograms/";

  static GET_CUSTOMER_ATTRIBUTE = Path.BASE_URL + "/outlet_attributes/customerattribute12/";

  // Promotion END POINTS

  static GET_ALL_ENUM = Path.BASE_URL + "/enum/all_enum/";

  // DURATION SECTION

  static GET_START_WEEK = Path.BASE_URL + "/enum/start_week/";

  static GET_END_WEEK = Path.BASE_URL + "/enum/end_week/";

  static GET_ACTIVITY = Path.BASE_URL + "activity/?limit=40"

  static POST_DOWNLOAD_DP_XLX = Path.BASE_URL + "/demand_planner/export_to_excel/";

  static POST_UPLOAD_DP_XLX = Path.BASE_URL + "/demand_planner/import_excel/";

  static GET_DEMAND_PLANNER_VERSIONS = Path.BASE_URL + "/demand_planner/fetch/versions/";

  static POST_FORCAST_ACCURACY_ANALYTICS = Path.BASE_URL + "/forecast/forecast_accuracy/";

  static POST_FORCAST_ACCURACY_REGINOL_ANALYTICS = Path.BASE_URL + "/forecast/forecast_accuracy_regional/";

  static POST_FORCAST_ACCURACY_REGINOL_ANALYTICS_LATEST = Path.BASE_URL + "/forecast/forecast_accuracy_regional_latest/";

  static POST_FORCAST_ACCURACY_REGINOL_ANALYTICS_LATEST_HUMAN = Path.BASE_URL + "/forecast/forecast_accuracy_latest/";

  static GET_FORCAST_DETAIL = Path.BASE_URL + "/forecast/detail_report/";

  // Prat Section Starting from here 
  static GET_PROMOTION = Path.BASE_URL + "/promotion/";


  static GET_SEGMENT = Path.BASE_URL + "/enum/segment/";

  static GET_NOTIFICATIONS = Path.BASE_URL + "/notification/";

  static POST_VIEWED_NOTIFICATIONS = Path.BASE_URL + "/notification/view/";

  // Approvals

  static GET_ACTIVITIES_LIST = Path.BASE_URL + "/activity/submitted_activities/";

  static DELETE_PROMOTION = Path.BASE_URL + '/activity/draft_delete/';

  static BULK_APPROVE_PROMOTIONS = Path.BASE_URL + '/activity/bulk_approve/';

  static BULK_DUPLICATE_PROMOTIONS = Path.BASE_URL + '/activity/bulk_duplicate/';

  static DOWNLOAD_PROMOTION_LIST = Path.BASE_URL + '/activity/export_list/';

  static GET_ACTIVITY_PLAN = Path.BASE_URL + '/activity/activity_plan/';

  static DOWNLOAD_ACTIVITY_NETWORK = Path.BASE_URL + '/activity_network/';

  static GET_OUTLET_SUMMARY = Path.BASE_URL + '/outlet/fetch_summary/';

  static GET_OPSO_ACCRUAL_REPORT = Path.BASE_URL + '/opso_accrual/';

  static DOWNLOAD_OPSO_ACCRUAL_REPORT = Path.BASE_URL + '/opso_accrual/export_list/';

  static GET_ALL_PROMOTION_TYPE = Path.BASE_URL + "/enum/promotion_type/";

  static EXCLUDE_OUTLET_FILTER = Path.BASE_URL + '/outlet/filter_for_excluding/';

  static EXCLUDE_FROM_SUMMARY = Path.BASE_URL + '/outlet/exclude_from_summary/';

  static GET_PRE_AND_POST_OPSO = Path.BASE_URL + '/prepost_opso/';

  static DOWNLOAD_SCHEME_REPORT = Path.BASE_URL + '/activity/export_scheme_report/';

  static DOWNLOAD_PRE_POST_OPSO = Path.BASE_URL + '/prepost_opso/export_post_opso/';

  static DOWNLOAD_PRE_POST_OPSO_TOTAL_CUT = Path.BASE_URL + '/prepost_opso/export_pre_vs_post_opso/';

  // static DJANGO_ADMIN_PANNEL = Path.AUTH_URL + 'admin/login';
  static DJANGO_ADMIN_PANNEL = Path.AUTH_URL + 'admin';

  static BULK_SEND_BACK_PROMOTION = Path.BASE_URL + '/activity/bulk_sendback/';

  static MAP_CATEGORIES = Path.BASE_URL + '/product_hierarchy/categories/map_categories/';

  static ACTIVATION_METRICS = Path.BASE_URL + '/prepost_opso/activation_metrics/';

  static TOP_TEN_ACTIVITIES_PRAT_DASH = Path.BASE_URL + '/prepost_opso/top_10_activities/';

  static POST_OPSO_RESULT_PRAT_DASH = Path.BASE_URL + '/prepost_opso/post_opso_division_level/';

  static TOP_BOTTOM_ACTIVITIES_PRAT_DASH = Path.BASE_URL + '/prepost_opso/top_bottom_5_activities/';

  static TTS_CHART = Path.BASE_URL + '/prepost_opso/tts_report/';

  static DTTS_CHART = Path.BASE_URL + '/prepost_opso/dtts_report/';

  static GT_MT_SPLIT = Path.BASE_URL + '/prepost_opso/gt_mt_report/';

  static CHANNEL_UTILIZATION = Path.BASE_URL + '/prepost_opso/channel_utilization_report/';

  static LOG_OUT = Path.BASE_URL + '/user/logout/';

  static GET_DEMAND_PLANNER_SEC_MAT = Path.BASE_URL + '/sale/mat_secondary_sale/';

  static GET_DEMAND_PLANNER_SEC_MAT_SALE_MSKU = Path.BASE_URL + '/sale/mat_secondary_sale_msku/';

  static BULK_RP_CALL = Path.BASE_URL + '/activity/bulk_call_reverse_pipeline/';

  static BASELINE_TOTAL_DEMAND = Path.BASE_URL + '/baseline/baseline_total/';

  static BULK_DUPLICATE_NEXT_YEAR = Path.BASE_URL + '/activity/bulk_duplicate_next_year/';

  static BASELINE_TOTAL_DEMAND_TIME_LINE = Path.BASE_URL + '/baseline/weekwise_baseline/';

  static GET_DEMAND_PLANNER_SEC_YOY = Path.BASE_URL + '/sale/yoy_secondary/';

  static DOWNLOAD_DTTS_XLSX = Path.BASE_URL + '/prepost_opso/dtts_report_export/';
  
  static DOWNLOAD_CHANNEL_UTI_XLSX = Path.BASE_URL + '/prepost_opso/channel_utilization_report_export/';
  
  static DOWNLOAD_TTS_XLSX = Path.BASE_URL + '/prepost_opso/tts_report_export/';
  
  static GET_ICE_CREAM_MASTER_CHANNEL = Path.BASE_URL + '/channel_hierarchy/master_channels/ice_cream/';
  
  static GET_ICE_CREAM_REGIONS = Path.BASE_URL + '/geo_hierarchy/regions/ice_cream/';

  static DOWNLOAD_ACTIVATION_MET_XLSX = Path.BASE_URL + '/prepost_opso/activation_metrics_export/';

  static DOWNLOAD_GT_MT_SPLIT_XLSX = Path.BASE_URL + '/prepost_opso/gt_mt_report_export/';

  static BULK_CALCULATE = Path.BASE_URL + '/activity/pre_opso/bulk-calculate/';

  static CREATE_CONSUMER_PROMOTION = Path.BASE_URL + '/activity/create_cp_promotion/';

  static CONSUMER_PROMOTION_TYPES = Path.BASE_URL + '/enum/cp_type/';

  static CONSUMER_PROMOTION_LIST = Path.BASE_URL + '/activity/list_cp_promotion/';

  static CONSUMER_PROMOTION_HISTORY = Path.BASE_URL + '/activity/history_cp_promotion/';

  static DELETE_CONSUMER_PROMOTION = Path.BASE_URL + '/activity/delete_cp_draft/';

  static INNOVATION = Path.BASE_URL + '/innovation/';

  static INNOVATION_VOLUME = Path.BASE_URL + '/innovation_volume/';

  static GET_PRODUCT_SECTORS = Path.BASE_URL + '/product_hierarchy/sector/fetch/';

  static GET_TARGET_YTD_BRAND = Path.BASE_URL + '/target/ytd_brand_level/';

  static GET_TARGET_TOTAL_SPENT = Path.BASE_URL + '/target/total_spend/';

  static DOWNLOAD_TARGET_TRACKER_XLSX = Path.BASE_URL + '/target/export_tt/';

  static GET_TARGET_YTD_BRAND_MTFTS = Path.BASE_URL + '/target/ytd_mtfts_brand_level/';
  
  static GET_TARGET_YTD_BRAND_ANP = Path.BASE_URL + '/target/ytd_anp_brand_level/';

  static CONSUMER_PROMOTION_LIST_COUNT = Path.BASE_URL + '/activity/list_finalized_null_cpcode/';

  static GET_TARGET_DTTS_BRAND = Path.BASE_URL + '/target/ytd_dtts_brand_level/';

  static GET_DEMAND_PLANNER_PRI_MAT = Path.BASE_URL + '/sale/mat_primary_sale/';

  static GET_DEMAND_PLANNER_PRI_MAT_SALE_MSKU = Path.BASE_URL + '/sale/mat_primary_sale_msku/';

  static GET_DEMAND_PLANNER_PRI_YOY = Path.BASE_URL + '/sale/yoy_primary/';

  static GET_DEMAND_PLANNER_DIFFERENCES = Path.BASE_URL + '/demand_planner/fetch/difference/';

  static GET_YEAR_WISE_GREG_WEEKS = Path.BASE_URL + '/enum/week_greg/';

  static GET_PDP_REPORT = Path.BASE_URL + '/pdp/lifts/';


}
